import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators'

import api from '@/api/api';
import DataSet from '@/models/DataSet';
import { ParameterCode } from '@/models/ParameterCode';
import TimeSeries from '@/models/TimeSeries';
import OrderedPair from '@/models/OrderedPair';
import SiteReference from '@/models/SiteReference';
import SiteData from '@/models/SiteData';

// TODO: investigate whether using 'dynamic modules' (initialized with an inflated module) could alleviate
//       the need for this super shitty fake active site...
//
// I think it will, and that this should be the way to handle this???
//
// https://championswimmer.in/vuex-module-decorators/pages/advanced/dynamic.html#step-2-create-the-dynamic-module
//
// Or alternatively... would 'null' work? see comments here...
//
// https://championswimmer.in/vuex-module-decorators/pages/core/state.html
//
// Instead right now
// - there's a dummy site refernce
// - it has a terrible property called "isNullSite"

const DummySiteReference = {
  siteNumber: '--------',
  siteName: '',
  lat: -1,
  lon: -1,
  state: 'CO',
  isNullSite: true
}

const DummySiteData = new SiteData();

@Module
export default class ActiveSite extends VuexModule {

  reference: SiteReference = DummySiteReference;
  data: SiteData = DummySiteData;

  @Mutation
  mutateSiteReference(reference: SiteReference) {
    this.reference = reference;
  }

  @Mutation
  mutateSiteData(data: SiteData) {
    this.data = data;
  }

  /**
   * Invoke when site reference is already loaded on the client
   */
  @Action({ commit: 'mutateSiteReference' })
  async setSiteReference(siteReference: SiteReference): Promise<SiteReference> {
    return siteReference;
  }

  /**
   * Invoke when site reference must be fetched from the OSF API
   */
  @Action({ commit: 'mutateSiteReference' })
  async loadSiteReference(siteNumber: string): Promise<SiteReference> {
    const siteReference = await api.getSite(siteNumber);
    return siteReference;
  }

  @Action({ commit: 'mutateSiteData' })
  async loadSiteData(siteReference: SiteReference): Promise<SiteData> {
    const data = await api.getAllSiteData(siteReference);
    return data;
  }

  @Action({ commit: 'mutateSiteReference' })
  async clearSiteReference(): Promise<SiteReference> {
    return { ... DummySiteReference };
  }

}
